import { forwardRef } from 'react';
import { Input, InputProps, StyledInput } from '../input';

export const UrlInput = forwardRef<HTMLInputElement, InputProps>(
  (props, ref): JSX.Element => {
    return (
      <Input {...props}>
        <StyledInput type="url" ref={ref} {...props} />
      </Input>
    );
  }
);
